import React from 'react';
import PropTypes from 'prop-types';
import './LegalContentCms.scss';

const LegalContentCms = ({ sections }) => (
  <div className="legal-content-cms">
    <div className="legal-content-cms__header">
      <h4 className="legal-content-cms__title">classpass</h4>
    </div>
    <ul className="legal-content-cms__body">
      {sections.map(section => (
        <li
          className="legal-content-cms__section"
          dangerouslySetInnerHTML={{ __html: section.content }}
          key={`legal-content-cms-section-${section.contentfulId}`}
        />
      ))}
    </ul>
  </div>
);

LegalContentCms.propTypes = {
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      content: PropTypes.string,
      contentfulId: PropTypes.string,
    })
  ),
};

export default LegalContentCms;
